export default "__VITE_ASSET__BvZYIW9u__"